import React from "react";
import { LineWave } from "react-loader-spinner";

import "./loader.scss";

const Loader = () => {
  return (
    <div className="loader">
      <LineWave
        color="red"
        firstLineColor="blue"
        middleLineColor="green"
        lastLineColor="grey"
        width={130}
        height={130}
      />
    </div>
  );
};

export default Loader;
